/**
 * 缩略卡片
 */

import * as React from 'react';
import classNames from 'classnames';
import styles from './MenuItem.module.less';

export default function MenuItem({ active, thumbnail, text, onChange }: any) {
  return (
    <div className={styles['menu-item']}>
      <div className={classNames(styles.img, { [styles.border]: active })} onClick={onChange}>
        <img src={thumbnail} alt="" />
      </div>
      <div className={classNames(styles.text, { [styles.bold]: active })}>{text}</div>
    </div>
  );
}
